import { lazy } from "react";
// ===========================================================================
// Pre-Visit Planning — Medical Assistant (Módulo D — BillingV2)
// Huddle sheet por cita para el MEDICAL ASSISTANT: documentación clínica que
// debe estar en el chart antes de la visita (labs, órdenes, care gaps,
// records externos).
//
// ORIGEN (2026-09-14): réplica del módulo `previsit-planning`, que quedó como
// el módulo del Medical Receptionist. La preparación de la visita se dividió
// en dos módulos por rol y cada uno tiene su checklist propio (ya no tabs):
//   - /previsit-planning     → Medical Receptionist (administrativo)
//   - /previsit-planning-ma  → Medical Assistant (clínico, ESTE módulo)
// Ambos escriben en el MISMO backend (TAB_APPOINTMENT_REV +
// TAB_PREVISIT_CHECKLIST): este módulo solo lee/escribe las filas con
// role "assistant", el otro las de role "receptionist" — el dato sigue
// compartido y el dialog de consulta del CDCI muestra los dos.
//
// ACCESO: lo gobierna la matriz RBAC y NADA MÁS — mismo módulo
// `previsit_planning` (25) del catálogo que el módulo del MR, mapeado en
// app/AccessDenied/roleRoutePermissions.js.
//
// El alcance de datos (qué citas ve cada uno) sigue en common/providerAccess.js:
// un médico mapeado ve solo sus citas; el staff no mapeado ve la jornada
// completa.
// ===========================================================================

// Lazy: nada del módulo viaja en el bundle inicial. AppRouter provee el Suspense.
const PrevisitPlanningPage = lazy(() => import("./pages/PrevisitPlanningPage"));

export const previsitPlanningMaRoutes = [
  {
    path: "/previsit-planning-ma",
    element: <PrevisitPlanningPage />,
  },
];

// Export utilities
export * from "./common/constants";
